import React from 'react';
import { View, useWindowDimensions } from 'react-native';
import ContentLoader from '../../../components/Common/LoadingComp/ContentLoader';
import RectLoader from '../../../components/Common/LoadingComp/RectLoader';

const FeedDetailsLoader = () => {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  const cardPadding = 20;
  const cardHeight = 1150;

  return (
    <View
      style={{
        marginHorizontal: isMobile ? 16 : 24
      }}>
      <ContentLoader speed={2} width='100%' height={cardHeight} viewBox={`0 0 ${width} ${cardHeight}`}>
        <RectLoader x={cardPadding} rx={20} ry={20} width={40} height={40} />
        <RectLoader x={cardPadding + 52} rx={8} ry={8} width={60} height={28} />

        <RectLoader x={cardPadding + 124} rx={6} ry={6} width={isMobile ? 160 : 260} height={20} />

        <RectLoader x={width - cardPadding - 120} rx={6} ry={6} width={120} height={18} />

        <RectLoader x={(width - 260) / 2} y={100} rx={16} ry={16} width={260} height={44} />

        <RectLoader x={cardPadding} y={170} rx={16} ry={16} width={width - cardPadding * 2} height={500} />

        <RectLoader x={cardPadding} y={410} rx={6} ry={6} width={140} height={20} />

        {[0, 1, 2].map(i => (
          <RectLoader
            key={i}
            x={cardPadding}
            y={450 + i * 80}
            rx={14}
            ry={14}
            width={width - cardPadding * 2}
            height={56}
          />
        ))}

        <RectLoader x={cardPadding} y={720} rx={6} ry={6} width={160} height={20} />
        <RectLoader x={cardPadding} y={760} rx={16} ry={16} width={width - cardPadding * 2} height={200} />
      </ContentLoader>
    </View>
  );
};

export default FeedDetailsLoader;
